export const getSanitizedItem = (options, value) =>
  options.find((option) => option.value === value);

export const getItemToString = (item) => item?.title || '';

export const handleOnChange =
  (onChange) =>
  ({ selectedItem }) =>
    onChange(selectedItem?.value);
